import React from 'react'
import ChatHeader from './ChatHeader'
import { getUserAvatar, hasAvatarImage } from '../../utils/avatarUtils'
import './styles/ChannelMessages.css'
import { BOT_USER_ID } from '../../utils'

function MembersModal({ members = [], onClose, userAvatars = [] }) {
  return (
    <div className="thread-list-window">
      <ChatHeader title="Members" onBack={onClose} />
      <div className="thread-list-content">
        {members.length === 0 ? (
          <div className="message-container">
            <span className="message-sender">No members found.</span>
          </div>
        ) : (
          members
            .filter((member) => member.username !== BOT_USER_ID)
            .map((member) => {
              const username = member?.username || member?.name
              return (
                <div key={member._id || username} className="member-item">
                  <div className="message-header">
                    <div className="message-avatar">
                      {hasAvatarImage(username, userAvatars) ? (
                        <img
                          src={getUserAvatar(username, userAvatars)}
                          alt={member?.name || username || 'User'}
                          className="avatar-image"
                          onError={(e) => {
                            e.target.style.display = 'none'
                            e.target.nextSibling.style.display = 'flex'
                          }}
                        />
                      ) : null}
                      <div
                        className={`avatar-fallback ${
                          hasAvatarImage(username, userAvatars) ? 'hidden' : ''
                        }`}
                      >
                        {getUserAvatar(username, userAvatars)}
                      </div>
                    </div>
                    <div className="message-header-content">
                      <span className="message-sender">
                        {member.name || username || 'Unknown'}
                      </span>
                    </div>
                  </div>
                </div>
              )
            })
        )}
      </div>
    </div>
  )
}

export default MembersModal
